module.exports = __webpack_public_path__ + "4d356f96451c04508b3ce7c316b075f7.pdf";